export const Z_INDEX_LIBRARY = {
  // Z-Index for the top bar
  TOP_BAR: 1000,
  // Z-Index for the mobile navigation
  MOBILE_NAVIGATION: 2000,
  // Z-Index for the modal
  MODAL: 3000,
  // Z-Index for the dropdown
  DROPDOWN: 4000,
  // Z-Index for the tooltip
  TOOLTIP: 2000,
  // Z-Index for the notification
  NOTIFICATION: 6000,
  // Z-Index for the overlay
  OVERLAY: 7000,
  // Z-Index for the loader
  LOADER: 8000,
  // Z-Index for the toast
  TOAST: 10000,
  // Z-Index for the cookie banner
  COOKIE_BANNER: 11000,
  // Z-Index for the language drawer
  LANGUAGE_DRAWER: 12000,
  // Z-Index for the drawer
  DRAWER: 2500,
  ARRANGE_LAYOUT_DIRECTION_OVERLAY: 13000,
};
